<script setup lang="ts">
interface Props {
  text?: string;
  ariaDescription?: string;
  icon?: string[] | string;
  canTriggerOverlay?: boolean;
  typography?: string;
}

withDefaults(defineProps<Props>(), {
  text: '',
  ariaDescription: '',
  canTriggerOverlay: false,
  typography: 'b600',
});
</script>

<template>
  <div class="relative flex w-full b600">
    <div class="w-16 pt-1">
      <fa-icon :aria-label="ariaDescription" :icon="icon" />
    </div>
    <p
      class="flex-1 whitespace-pre-line"
      v-if="text"
      :aria-label="text"
      :class="typography"
    >
      {{ text }}
    </p>

    <slot class="flex-1" v-else></slot>

    <fa-icon v-if="canTriggerOverlay" :icon="['fal', 'fa-angle-right']" />
  </div>
</template>
